<template>
  <div class="box_footer">
    <div class="footer">
      <div class="floatLeft w532">
        <div class="textLeft marignd30"><img src="@/assets/footerlogo.png" /></div>
        <div class="f_left">
          <p>德心合（北京）健康管理集团</p>
          <p class="floatLeft">德心合（上海）心理咨询有限公司</p>
          <p class="floatLeft marignr35">德心合（新加坡）心理咨询有限公司</p>
          <p class="floatLeft">德心合（江苏）心理咨询有限公司</p>
          <p class="floatLeft marignr35">德心合（洛杉矶）心理咨询有限公司</p>
          <p class="floatLeft">德心合（厦门）心理咨询有限公司</p>
          <p class="floatLeft marignr35">德心合（悉尼）心理咨询有限公司</p>
          <p class="floatLeft">德心合（杭州）心理咨询有限公司</p>

          <p class="floatLeft" style="width:100%;">德心合（深圳）心理咨询有限公司</p>
          <p class="floatLeft">德心合（香港）心理咨询有限公司（筹建中）</p>
        </div>
      </div>
      <div class="floatRight w400">
        <p class="p1"><a v-for="(row,index) in list" href="javascript:;" :key="index"
            @click="handel(index)">{{row.name}}</a></p>
        <p class="p2">联系电话：<b>021-6221-5969</b></p>
        <p class="p3">联系地址：上海市静安区寿阳路99弄2号楼 科翔高新三楼</p>
      </div>
    </div>
    <p class="textCenter">
      <img src="@/assets/logo01.png" />
	  <a href="https://beian.mps.gov.cn/#/query/websearch?code=31011202020151\" rel="noreferrer" target="_blank">沪公网安备31011202020151</a>
	  &nbsp;&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024046519号-1</a>
    </p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [{
            name: '首页'
          },
          {
            name: '企业介绍'
          },
          {
            name: '专家团队'
          },
          {
            name: '心理知识'
          },
          {
            name: '联系我们'
          }
        ]
      }
    },
    methods: {
      handel(index) {
        this.$emit("customEvent", index);
      }
    }
  }
</script>

<style scoped>
  .textCenter {
    display: flex;
    /* 将容器设置为flex布局 */
    align-items: center;
    /* 在交叉轴上对齐项目 */
    justify-content: center;
    /* 在主轴上水平居中项目 */
    margin-top: 15px;
  }

  .textCenter img {
    width: 20px;
    padding-right: 10px;
  }

  .textCenter a {
    color: #fff;
    font-size: 14px;
  }

  .box_footer {
    background: #313131;
    padding: 50px 0 25px 0;
  }

  .footer {
    width: 950px;
    display: flex;
    margin: 0 auto;
  }

  .f_left p {
    line-height: 22px;
    text-align: left;
    color: #fff;
    font-size: 14px;
  }

  .textRight {
    text-align: right;
  }

  .textLeft {
    text-align: left;
  }

  .marignr35 {
    margin-left: 35px;
  }

  .marignd30 {
    margin-bottom: 30px;
  }

  .marignd30 img {
    width: 254px;
  }

  .w532 {
    width: 532px;
  }

  .w400 {
    width: 400px;
  }

  .floatRight .p1 {
    padding-top: 20px;
    line-height: 42px;
    text-align: right;
  }

  .floatRight .p1 a {
    color: #fff;
    padding: 0 10px;
    border-right: 1px solid #fff;
    font-size: 14px;
  }

  .floatRight .p1 a:hover {
    color: #23B6B0;
  }

  .floatRight .p1 a:last-child {
    border: 0;
  }

  .floatRight .p2 {
    margin-top: 120px;
    line-height: 30px;
    font-size: 14px;
    height: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    /* 将项目在交叉轴上居中对齐 */
    justify-content: right;
    /* 将项目在主轴上居中对齐（水平居中） */

  }

  .floatRight .p2 b {
    font-size: 18px;
    padding-left: 5px;
    letter-spacing: 2px;
  }

  .floatRight .p3 {
    text-align: right;
    color: #fff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/vfooter.vue